document.addEventListener('DOMContentLoaded', () => {
  // Find all media popup sections on the page
  const mediaSections = document.querySelectorAll('.kb-media-popup-section .kb-box-media');

  mediaSections.forEach((mediaBox) => {
    const sectionId = mediaBox.getAttribute('data-section-id');
    const popupBtn = mediaBox.querySelector(`#video-pop-btn-${sectionId}`);
    const closeBtn = mediaBox.querySelector(`#video-pop-close-${sectionId}`);
    const iframe = mediaBox.querySelector('iframe');
    const baseSrc = iframe?.getAttribute('data-src');

    if (popupBtn && iframe && baseSrc) {
      popupBtn.addEventListener('click', () => {
        // Add active class to kb-box-media
        mediaBox.classList.add('video-popup-active');
        // Add autoplay to iframe src
        iframe.src = `${baseSrc}?autoplay=1`;
        // Show close button
        closeBtn.classList.remove('d-none');
      });
    }

    if (closeBtn && iframe) {
      closeBtn.addEventListener('click', () => {
        // Remove active class from kb-box-media
        mediaBox.classList.remove('video-popup-active');
        // Reset iframe src to stop video
        iframe.src = baseSrc;
        // Hide close button
        closeBtn.classList.add('d-none');
      });
    }
  });
});
